export const resolveGlobalFilterFromUrl = (urlParams: URLSearchParams): string | undefined => {
  const globalFilter = urlParams.get("globalFilter");

  if (!globalFilter) {
    return undefined;
  }

  return globalFilter;
};

export const encodeGlobalFilterToUrl = (
  urlParams: URLSearchParams,
  globalFilter: string | undefined,
): URLSearchParams => {
  const updatedParams = new URLSearchParams(urlParams);

  if (globalFilter) {
    updatedParams.set("globalFilter", globalFilter);
  } else {
    updatedParams.delete("globalFilter");
  }

  return updatedParams;
};
